import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import './index.css';
import MainPage from './pages/MainPage';
import NotFoundPage from './pages/NotFoundPage';
import { unregister } from './serviceWorkerRegistration';

const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <App />,
            errorElement: <NotFoundPage />,
            children: [
                {
                    index: true,
                    path: '/',
                    element: <MainPage />,
                },
            ],
        },
        {
            path: '*',
            element: <NotFoundPage />,
        },
    ],
    {
        basename: '/',
    }
);

// Request notification permission on first interaction
document.addEventListener(
    'click',
    () => {
        if ('Notification' in window && Notification.permission !== 'granted') {
            Notification.requestPermission().catch(() => undefined);
        }
    },
    { once: true }
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterProvider router={router} />);

// Unregister old service worker and clear all caches immediately
if ('caches' in window) {
    caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
}
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
}
unregister();
